import { render, staticRenderFns } from "./setpItemHall.vue?vue&type=template&id=f5abe0d8&scoped=true"
import script from "./setpItemHall.vue?vue&type=script&lang=js"
export * from "./setpItemHall.vue?vue&type=script&lang=js"
import style0 from "./setpItemHall.vue?vue&type=style&index=0&id=f5abe0d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5abe0d8",
  null
  
)

export default component.exports